// extracted by mini-css-extract-plugin
export default {"wrapperDonateBoy":"DonateBoy_wrapperDonateBoy__aQYwH"};